'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

require('./AppLoader.scss');

var _components = {
  _$AppLoader: {
    displayName: 'AppLoader'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppLoader/AppLoader.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppLoader/AppLoader.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var AppLoader = (function (_Component) {
  _inherits(AppLoader, _Component);

  function AppLoader() {
    _classCallCheck(this, _AppLoader);

    _Component.apply(this, arguments);
  }

  AppLoader.prototype.render = function render() {
    var _props = this.props;
    var theme = _props.theme;
    var size = _props.size;

    var sizes = size ? size + 'px' : '50px';

    var styles = {
      width: sizes,
      height: sizes
    };

    return _react2['default'].createElement(
      'div',
      { className: theme ? 'loader loader--' + theme : 'loader loader--dark', style: styles },
      _react2['default'].createElement(
        'svg',
        { className: 'loader__svg', viewBox: '25 25 50 50' },
        _react2['default'].createElement('circle', { className: 'loader__path', cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
      )
    );
  };

  _createClass(AppLoader, null, [{
    key: 'propTypes',
    value: {
      theme: _react.PropTypes.string,
      size: _react.PropTypes.string
    },
    enumerable: true
  }]);

  var _AppLoader = AppLoader;
  AppLoader = _wrapComponent('_$AppLoader')(AppLoader) || AppLoader;
  return AppLoader;
})(_react.Component);

exports['default'] = AppLoader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppLoader/AppLoader.js
// module id = 665
// module chunks = 0